export function formatearImporteInsights(valor) {
  return (valor ?? 0).toLocaleString("es-ES", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true,
  });
}

export function formatearPctInsights(valor) {
  if (valor == null || Number.isNaN(Number(valor))) return "—";
  return `${Number(valor).toLocaleString("es-ES", {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  })} %`;
}

export function formatearFechaCortaInsights(iso) {
  if (!iso) return "—";
  const parts = String(iso).split("-");
  if (parts.length !== 3) return iso;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

export function kpiVentaTone(ventaYtdVsLyPct) {
  return (ventaYtdVsLyPct ?? 0) >= 0 ? "good" : "bad";
}

export function kpiCfTone(cfAcumuladoHoy) {
  return (cfAcumuladoHoy ?? 0) >= 0 ? "good" : "bad";
}

export function kpiPresupuestoTone(desviacionVsPresupuestoPct) {
  return Math.abs(desviacionVsPresupuestoPct ?? 0) <= 5 ? "good" : "warn";
}

export function kpiResultadoTone(resultadoExplotacionYtd) {
  return (resultadoExplotacionYtd ?? 0) >= 0 ? "good" : "bad";
}
